// extracted by mini-css-extract-plugin
module.exports = {"mouse-tooltip":"MouseTooltip_mouse-tooltip__3dYU4"};